import { EventrDate } from '@eventr/common'
import { DateTimePicker, DateTimePickerProps } from '@eventr/common-storybook'
import { Controller } from 'react-hook-form'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { bs, useBoundStore } from '../../../state/bound.store'
import { useLanguageContext } from '../../../state/languageState/languageContext'

interface IFormDateTimeProps
    extends Omit<DateTimePickerProps, 'onChange' | 'eventrDateString'> {
    control: any
    name: string
}
export const FormDateTime = (props: IFormDateTimeProps) => {
    const { control, name, ...rest } = props
    const { getEventInfoV2 } = useBoundStore(
        useShallow((s) => {
            return {
                getEventInfoV2: s.getEventInfoV2,
            }
        })
    )
    const { getLanguageISO639Code } = useLanguageContext()

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                const _onChange = (val: string | undefined) => {
                    onChange(val ?? null)
                    if (val) bs().setLastUsedDateTime(val)
                }

                return (
                    <DateTimePicker
                        id={`${name}-selector`}
                        eventrDateString={value}
                        dateHeaderTitle={i18n.t(
                            'edit-itinerary.fields.select-date'
                        )}
                        timeHeaderTitle={i18n.t(
                            'edit-itinerary.fields.select-time'
                        )}
                        isError={!!error}
                        outOfRangePopup
                        textError={error?.message}
                        onChange={_onChange}
                        initialState={getEventInfoV2()?.data.start_date}
                        minDate={
                            new EventrDate(getEventInfoV2()?.data.start_date)
                        }
                        maxDate={
                            new EventrDate(getEventInfoV2()?.data.end_date)
                        }
                        locale={getLanguageISO639Code()}
                        saveText={i18n.t('general.done')}
                        clearText={i18n.t('general.clear')}
                        minuteText={i18n.t('general.minute')}
                        hourText={i18n.t('general.hour')}
                        selectDateText={i18n.t(
                            'edit-itinerary.fields.select-date'
                        )}
                        selectTimeText={i18n.t(
                            'edit-itinerary.fields.select-time'
                        )}
                        highlightRangeStart={getEventInfoV2()?.data.start_date}
                        highlightRangeEnd={getEventInfoV2()?.data.end_date}
                        {...rest}
                    />
                )
            }}
        ></Controller>
    )
}
